import { fbt } from 'fbtee'
import { Settings } from 'lucide-react'
import { Button } from '../../components/ui/button'
import { useTransitionNavigate } from '../../lib/viewTransition'

/** The header gear: opens the group's settings screen (admins see more there). */
export function GroupSettingsButton({ groupId }: { groupId: string }) {
  const navigate = useTransitionNavigate()
  return (
    <Button
      variant="outline"
      size="icon"
      className="size-9"
      aria-label={fbt('Group settings', 'Accessible label of the settings menu button in the group page header')}
      data-testid="group-settings-button"
      onClick={() => navigate(`/groups/${groupId}/settings`)}
    >
      <Settings className="size-4" />
    </Button>
  )
}
